import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import * as _ from 'lodash-es';

/**
 * Gold Address service.
 * Load address (b8xqv1), update (72ge4k), change (4j7huk), new (fe783a), address search (o0p09p), entity search (8fr4bk).
 */
@Injectable({
  providedIn: 'root'
})
export class GoldAddressService {

  constructor(private http: HttpClient) {}

  loadAddress(baseUrl: string, addressId: string | number, globalService?: any, filterParams?: any): Observable<any> {
    const params: Record<string, string> = {
      action_code: 'b8xqv1',
      address_id: String(addressId ?? '')
    };
    return this.loadJson(baseUrl, params).pipe(
      map((arr: any[]) => (arr && arr[0]) ? this.keysToLower(arr[0]) : {})
    );
  }

  saveUpdate(baseUrl: string, address: any, globalService: any, filterParams: any = {}): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=72ge4k`;
    const payload = [this.keysToUpper(address)];
    return this.postSave(baseUrl, url, payload, globalService, filterParams);
  }

  saveChange(baseUrl: string, rowData: any, selectedAddressId: number, globalService: any, filterParams: any = {}): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=4j7huk`;
    const payload = [{
      OBJECT_ID: rowData?.key ?? rowData?.KEY,
      ADDRESS_ID: selectedAddressId,
      LEGAL_ENTITY_NAME: rowData?.legal_entity_name ?? rowData?.LEGAL_ENTITY_NAME
    }];
    return this.postSave(baseUrl, url, payload, globalService, filterParams);
  }

  saveNew(baseUrl: string, address: any, globalService: any, filterParams: any = {}): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=fe783a`;
    const payload = [this.keysToUpper(address)];
    return this.postSave(baseUrl, url, payload, globalService, filterParams);
  }

  searchAddress(baseUrl: string, searchString: string): Observable<any[]> {
    const params: Record<string, string> = {
      action_code: 'o0p09p',
      search_string: searchString || ''
    };
    return this.loadJson(baseUrl, params).pipe(
      map((arr: any[]) => Array.isArray(arr) ? arr.map(o => this.keysToLower(o)) : [])
    );
  }

  searchEntity(baseUrl: string, searchString: string): Observable<any[]> {
    const params: Record<string, string> = {
      action_code: '8fr4bk',
      search_string: searchString || ''
    };
    return this.loadJson(baseUrl, params).pipe(
      map((arr: any[]) => Array.isArray(arr) ? arr.map(o => this.keysToLower(o)) : [])
    );
  }

  private postSave(baseUrl: string, url: string, payload: any[], globalService: any, filterParams: any): Observable<any> {
    let params = _.merge({}, globalService?.globalParams || {}, filterParams || {});
    params = _.extend({ jsonObj: JSON.stringify(payload) }, params);
    params = _.extend({ jsonSettings: '{}' }, params);
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, String(params[key]));
      }
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  private loadJson(baseUrl: string, params: Record<string, string>): Observable<any[]> {
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => urlEncoded.set(key, params[key]));
    const url = `${baseUrl}/loadJsonObject?${urlEncoded.toString()}`;
    return this.http.get<any>(url, { withCredentials: true }).pipe(
      map((data: any) => {
        if (data?.callSuccess !== '1') return [];
        const arr = data?.jsonObject;
        return Array.isArray(arr) ? arr : [];
      })
    );
  }

  private keysToLower(o: any): any {
    if (!o || typeof o !== 'object') return o;
    const r: any = {};
    Object.keys(o).forEach(k => { r[k.toLowerCase()] = o[k]; });
    return r;
  }

  private keysToUpper(o: any): any {
    if (!o || typeof o !== 'object') return o;
    const r: any = {};
    Object.keys(o).forEach(k => { r[k.toUpperCase()] = o[k]; });
    return r;
  }
}
